import http from "../http";
export default {
  getList(params) {
    return http.get("/work_order/keywordQa/list", { params });
  },
  getInfo(params) {
    return http.get(`/work_order/keywordQa/info/${params.id}`);
  },
  create(params) {
    return http.post("/work_order/keywordQa/create", params);
  },
  deleteById(params) {
    return http.delete(`/work_order/keywordQa/delete/${params.id}`);
  },
  editById(params) {
    return http.post("/work_order/keywordQa/edit", params);
  },
};
